/** `residencyRegion` value that gates storage-backed console surfaces. */
export const TENANT_NO_STORAGE_RESIDENCY_REGION = 'no-storage'
